import React from 'react';
import type { HomeSectionId } from '../../navigation/goToSection';
import { Icon } from './icons';

type SectionCtaProps = { children: React.ReactNode; className?: string } & (
  | { to: HomeSectionId; href?: never }
  | { href: string; to?: never }
);

/**
 * WU-AD: the one call to action a section ends on. `to` scrolls to a home section (the calculator or the
 * store badges); `href` opens an outside link (WhatsApp) in a new tab. The colour follows the section surface.
 * It only renders on the home page, beside its targets, so it scrolls in place like goToSection does there,
 * without the router (which also keeps it usable in tests that do not stub react-router-dom).
 */
const SectionCta: React.FC<SectionCtaProps> = ({ children, className, to, href }) => {
  const classes = className ? `ui-section-cta ${className}` : 'ui-section-cta';
  const content = (
    <>
      <span>{children}</span>
      <span className="ui-section-cta__arrow">
        <Icon name="arrow-right" size={20} />
      </span>
    </>
  );

  if (href != null) {
    return (
      <a className={classes} href={href} target="_blank" rel="noopener noreferrer">
        {content}
      </a>
    );
  }
  const scrollToTarget = () =>
    document.getElementById(to as HomeSectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return (
    <button type="button" className={classes} onClick={scrollToTarget}>
      {content}
    </button>
  );
};

export default SectionCta;
